/* eslint-disable better-mutation/no-mutation */
import { createSlice } from '@reduxjs/toolkit';
import { getRecentSearchesLocalStorage } from './helpers';

export const initialState = {
    brands: {
        items: [],
        status: 'NOT_FETCHED'
    },
    searches: {
        items: [],
        status: 'NOT_FETCHED'
    },
    recentSearches: []
};

const getInitialState = () => {
    const recentSearches = getRecentSearchesLocalStorage() || [];

    return {
        ...initialState,
        recentSearches
    };
};

const personalisationSlice = createSlice({
    name: 'personalisation',
    initialState,
    reducers: {
        initialize: (_state, { payload }) => {
            return getInitialState(payload);
        },
        initializeRecentSearches: (state, { payload }) => {
            state.recentSearches = payload;
        },
        setPersonalisedSearches: (state, { payload }) => {
            state.searches = payload;
        },
        setPersonalisedSearchesStatus: (state, { payload }) => {
            state.searches.status = payload;
        },
        setRecentSearches: (state, { payload }) => {
            const recentSearchIndex = state.recentSearches.findIndex(
                (search) => search.text === payload.text
            );

            if (recentSearchIndex > -1) {
                state.recentSearches[recentSearchIndex].count = payload.count;
                state.recentSearches[recentSearchIndex].queryParams =
                    payload.queryParams;

                // Move the search to the top of the list
                state.recentSearches.unshift(
                    state.recentSearches.splice(recentSearchIndex, 1)[0]
                );
            } else {
                state.recentSearches.unshift(payload);
            }
        },
        removeRecentSearch: (state, { payload }) => {
            state.recentSearches = state.recentSearches.filter(
                (search) => search.text !== payload
            );
        }
    }
});

export const {
    initialize,
    initializeRecentSearches,
    setPersonalisedSearches,
    setPersonalisedSearchesStatus,
    setRecentSearches,
    removeRecentSearch
} = personalisationSlice.actions;

export const reducer = personalisationSlice.reducer;
